import { FC } from "react";

const DropdownStatusColorMeaning: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <button className="btn-link nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
          Status Color <span className="d-lg-none d-xl-inline-block">Meaning</span>
      </button>

      <ul className="colors-dropdown dropdown-menu dropdown-menu-end p-2">
        <p   aria-expanded="false">
          On the case screen, you can see the status of your case in real time. The status is also color-coded to make it easier to see what is happening at a glance.
        </p>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <span className="btn btn-block bg-orange text-white my-1 w-100">
             Action by Insurance is required, such as a determination
          </span>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <span className="btn btn-block bg-green text-white my-1 w-100">
            Prescription has been transferred to specialty pharmacy
          </span>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <span className="btn btn-block bg-blue text-white my-1 w-100">
            Action is required by FUROSCIX Direct
          </span>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
           <span className="btn btn-block bg-purple text-white my-1 w-100">
             Action or documentation is required by the patient
           </span>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <span className="btn btn-block bg-yellow my-1 w-100">
            Action or documentation is required by you, such as clinical documentation
          </span>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <span className="btn btn-block bg-red text-white my-1 w-100">
            Request has been cancelled
          </span>
        </li>
      </ul>
    </li>
      // <li className="nav-item dropdown">
      //    <button className="btn btn-link nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
    //      Status Color Meaning
    //    </button>
    //     <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
    //       <form className="px-2">
    //         <div className="form-group">
    //           On the case screen, you can see the status of your case in real time. The status is also color-coded to make it easier to see what is happening at a glance.
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-orange text-white my-1">
    //                 Action by Insurance is required, such as a determination
    //               </span>
    //             </div>
    //           </div>
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-green text-white my-1">
    //                 Prescription has been transferred to specialty pharmacy
    //               </span>
    //             </div>
    //           </div>
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-blue text-white my-1">
    //                 Action is required by FUROSCIX Direct
    //               </span>
    //             </div>
    //           </div>
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-purple text-white my-1">
    //                 Action or documentation is required by the patient
    //               </span>
    //             </div>
    //           </div>
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-yellow my-1">
    //                 Action or documentation is required by you, such as clinical documentation
    //               </span>
    //             </div>
    //           </div>
    //           <div className="dropdown-divider"></div>
    //           <div className="form-row">
    //             <div className="col-12">
    //               <span className="btn btn-block bg-red text-white my-1">
    //                 Request has been cancelled
    //               </span>
    //             </div>
    //           </div>
    //         </div>
    //       </form>
    //     </div>
    //   </li>
  );
};

export default DropdownStatusColorMeaning;
